import { RegisterLinkClick } from './analytics-helper';


export function downloadDomoReport(requestUrl: string, bearerToken: string) {
    const controller = new AbortController();
    const options = {
        headers: {
            Authorization: `Bearer ${bearerToken}`,
        },
        signal: controller.signal,
    };

    setTimeout(() => {
        controller?.abort();
    }, 60000);


    fetch(requestUrl, options)
        .then(res => {
            if (!res.ok) {
                throw new Error(`Download Error: ${res.statusText}`);
            }

            return res.blob();
        })
        .then((blob: Blob) => {
            if (blob.size === 0) {
                throw new Error(`No data: ${requestUrl}`);
            }

            const file = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement('a');
            downloadLink.href = file;
            downloadLink.target = '_blank';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

        });
}
export function downloadFileFromApi(requestUrl: string, bearerToken: string, fileName: string, onSuccess?: () => void, onError?: () => void) {


    const controller = new AbortController();
    const options = {
        headers: {
            Authorization: `Bearer ${bearerToken}`,
        },
        signal: controller.signal,
    };

    setTimeout(() => {
        controller?.abort();
    }, 60000);

    RegisterLinkClick(fileName, requestUrl);

    fetch(requestUrl, options)
        .then(res =>{
            if (!res.ok){
                throw new Error(`Download Error: ${res.statusText}`);
            }

            return res.blob();
            })
        .then((blob: Blob) => {
            if (blob.size === 0){
                throw new Error(`No data: ${requestUrl}`);
            }

            const file = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement('a');
            downloadLink.href = file;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            if (onSuccess) onSuccess();
        }).catch(() => {
            if (onError) onError();
        });
}


export function createJsonFile(fileName: string, json: Object) {
	return new File([new Blob([JSON.stringify(json)])], fileName, { type: 'application/json' });
}

export function renameFile(file: File) {
	return new File([file], `${Date.now()}-${file.name}`);
}

export function downloadFileFromApiAndOpenNewTab(requestUrl: string, bearerToken: string, fileName: string, onSuccess?: () => void, onError?: () => void) {


    const controller = new AbortController();
    const options = {
        headers: {
            Authorization: `Bearer ${bearerToken}`,
        },
        signal: controller.signal,
    };

    setTimeout(() => {
        controller?.abort();
    }, 60000);

    RegisterLinkClick(fileName, requestUrl);

    fetch(requestUrl, options)
        .then(res =>{
            if (!res.ok){
                throw new Error(`Download Error: ${res.statusText}`);
            }

            return res.blob();
            })
        .then((blob: Blob) => {
            if (blob.size === 0){
                throw new Error(`No data: ${requestUrl}`);
            }

            const file = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement('a');
            downloadLink.href = file;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            if (onSuccess) onSuccess();
        }).catch(() => {
            if (onError) onError();
        });
}